// ReviewScreen.jsx
import React, { useContext, useMemo } from 'react';
import html2canvas from 'html2canvas';
import { useNavigate } from 'react-router-dom';
import { FormContext } from '../../context/FormContext';
import { calculateInvoice } from '../../utils/calculateInvoice';
import { pdf } from '@react-pdf/renderer';
import InvoicePdf from './InvoicePDF';
import ContentBox from './ContentBox';
import { ArrowForward } from '@mui/icons-material';

export default function Success() {
  const { formData } = useContext(FormContext);
  const navigate = useNavigate();
  const result = useMemo(() => calculateInvoice(formData), [formData]);

  const viewPdf = async () => {
    const blob = await pdf(<InvoicePdf data={formData} result={result} />).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url);
  };

  const viewArchive = () => {
    navigate('/archive');   
  };

  // Blob -> **raw** base64 (Mailjet needs raw, not a data URL)
  const blobToBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const dataUrl = reader.result; // "data:application/pdf;base64,AAAA..."
        const base64 = String(dataUrl).split('base64,')[1];
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

  const emailInvoice = async () => {
    try {
      // 1) Render PDF to Blob
      const blob = await pdf(<InvoicePdf data={formData} result={result} />).toBlob();

      // 2) Convert to raw base64
      const base64Pdf = await blobToBase64(blob);

      // 3) Build payload for your Mailjet endpoint
      const filename = `Invoice-${formData.igHandle || formData.handle || 'user'}-${Date.now()}.pdf`;

      const amount = result?.userClaim ?? '0';

      const fromName = formData?.fullName ?? '';
      const handle = formData?.igHandle ?? '';

      const payload = {
        to: formData?.email || 'test@test.com',
        subject: 'Invoice for unpaid creative labour',
        text: `Invoice amount: $${amount}`,
        html: `<p>Invoice amount: <strong>$${amount}</strong><br/>From: ${fromName} (${handle})</p>`,
        filename,
        base64Pdf,
        handle,
        amount,
      };

      // 4) Send via your backend
      const res = await fetch('/api/send-invoice', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || 'Mail send failed');
      }

      navigate('/success');
    } catch (err) {
      console.error(err);
      alert('Sorry — emailing the invoice failed. Please try again.');
    }
  };

  const shareCard = () => {
    const card = document.getElementById('share-card');
    if (!card) return;

    html2canvas(card, { scale: 2, useCORS: true }).then((canvas) => {
      const link = document.createElement('a');
      link.download = `invoice-meta-${formData.igHandle || formData.handle || 'user'}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    });
  };

  const startOver = () => {
    localStorage.removeItem('invoiceMetaForm');
    window.location.href = '/';
  };

  return (
    <ContentBox>
      {/* <div className="final-wrapper"> */}
      <div className="intro-main">
        <h1 style={{margin: 0}}>Your Invoice Has Been Sent!</h1>


        <p style={{marginTop: 0}}>
          Your invoice has been <b>generated</b>.<br/><br/>
          Your value has been <b>measured</b>.<br/><br/>
          Your lost wellbeing has been <b>quantified</b>.
        </p>

        <div style={{display: 'flex', flexDirection: 'column', gap: 10, width: '100%'}} >
          <button onClick={viewPdf}>Preview Invoice</button>
          <button style={{background: '#ddddddff', color: 'black'}} onClick={viewArchive}>View Archive</button>
        </div>
        
        <a href='https://www.youtube.com/watch?v=Jo8jmv4l2IE' target='_blank' className='link'>Ease Your Mind<ArrowForward></ArrowForward></a>
      </div>

      {/* Hidden Share Card ... (unchanged) */}
      <div id="share-card" /* ...snip... */ />
      {/* </div> */}
    </ContentBox>
  );
}
